import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAllChildren } from "@/hooks/useAllChildren";
import { PersonStanding, Users, TrendingUp, Settings, type LucideIcon } from "lucide-react";

interface NavItem {
  label: string;
  icon: LucideIcon;
  path: string;
  splitOnly?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { label: "Barn", icon: PersonStanding, path: "/dashboard" },
  { label: "Samarbeid", icon: Users, path: "/custody", splitOnly: true },
  { label: "Utvikling", icon: TrendingUp, path: "/reports" },
  { label: "Innstillinger", icon: Settings, path: "/settings" },
];

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasAnySplitChild } = useAllChildren();

  const visibleItems = NAV_ITEMS.filter(
    (item) => !item.splitOnly || hasAnySplitChild
  );

  return (
    <nav className="shrink-0 border-t border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/85 pb-[env(safe-area-inset-bottom,0px)]">
      <div className="mx-auto flex max-w-sm items-stretch py-1.5">
        {visibleItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex flex-1 flex-col items-center gap-1 rounded-xl py-2 text-[0.8rem] transition-colors",
                isActive
                  ? "text-primary font-semibold bg-secondary"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon className={cn("h-6 w-6", isActive && "stroke-[2.5]")} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
